import type { AttributeFilters } from '../attributeFilters';
import type { PolicyBaseWithId } from './PolicyBase';
import type { PolicyWithApiScopes } from './PolicyWithApiScopes';

export type PolicyWithAttributeScopes = PolicyBaseWithId & {
  attributeFilters: AttributeFilters;
  scopeType: 'attributeScopes';
};

export const isPolicyWithAttributeScopes = (
  x: PolicyWithApiScopes | PolicyWithAttributeScopes | undefined,
): x is PolicyWithAttributeScopes => x?.scopeType === 'attributeScopes';
